import './polyfills/mic-recorder-polyfill';
import { InitializeRegion } from './helpers/RegionCodes';

// Initialize zynga scroller globals early
import './components/zynga/Scroller';

async function initializeApp() {
  if (window.location.pathname.indexOf('/popup_callback') === 0) {
    const { default: popupCallback } = await import('./auth/PopupCallback');
    popupCallback();
  } else if (window.location.pathname.indexOf('/silent_renew') === 0) {
    const { default: silentRenew } = await import('./auth/SilentRenew');
    silentRenew();
  } else if (window.location.pathname.indexOf('/set-logout') === 0) {
    localStorage.removeItem('siftSessionId');
    const { v4 } = await import('uuid');
    localStorage.setItem('logout', v4());
  } else if (window.location.pathname.indexOf('/set-regioncode') === 0) {
    InitializeRegion();
  } else if (window.location.pathname.indexOf('/switch-account') === 0) {
    const { v4 } = await import('uuid');
    localStorage.setItem('switchAccount', v4());
  } else if (window.location.pathname.indexOf('/sift-session') === 0) {
    const siftUrl = new URL(window.location.href);
    const siftSessionId = siftUrl.searchParams.get('id');
    !!siftSessionId && localStorage.setItem('siftSessionId', siftSessionId);
  } else {
    const { default: library } = await import('./library');
    await library('goformz-app');
  }
}

// Initialize the app
initializeApp().catch(console.error);
